import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { META_PIXEL_ID } from './data/content';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vkuoemiy5k6">
      <div className="min-h-screen w-full bg-white font-sans text-negro antialiased selection:bg-amarillo selection:text-navy" data-id="element-1" data-mp="23ujl6el5pr4k">
        <noscript data-id="element-2" data-mp="3ihv1ac76whht">
          <img height="1" width="1" style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="3mlj6wpc9h30f" />
        </noscript>

        <Hero data-id="element-4" data-mp="4n4bxqxqh8g" />
        <main data-id="element-5" data-mp="5ggxfcks0yi">
          <ProblemSection data-id="element-6" data-mp="82k72sfnuax" />
          <SolutionSection data-id="element-7" data-mp="2zld0746gb58w" />
          <BonusesSection data-id="element-8" data-mp="2zm4zaoz9bl3x" />
          <BenefitsSection data-id="element-9" data-mp="2zmwj72jhrued" />
          <OfferSection data-id="element-10" data-mp="33mov9p83gioh" />
          <GuaranteeSection data-id="element-11" data-mp="33m5e4aq9pybi" />
          <Testimonials data-id="element-12" data-mp="33n6zp94wu37h" />
          <FAQSection data-id="element-13" data-mp="33ork45xig5rm" />
          <FinalCTA data-id="element-14" data-mp="38m1gy6n8bjph" />
        </main>
        <Footer data-id="element-15" data-mp="38kqgafp2ys2l" />
        <PurchasePopup data-id="element-16" data-mp="38k6wsujs7vmg" />
      </div>
    </MotionConfig>;
}